import { BrowserRouter } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import AppRoutes from './AppRoutes';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { ScrollToTop } from './components/common/ScrollToTop';

function App() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#ffffff', color: '#000000' }}>
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <AppRoutes />
          <Analytics />
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
